import { Component } from '@angular/core';

@Component({
  selector: 'panel-b2b-export-confirm-dialog',
  templateUrl: './export-confirm-dialog.component.html',
  styleUrls: ['./export-confirm-dialog.component.scss'],
})
export class ExportConfirmDialogComponent {}
